export default __webpack_public_path__ + "static/media/D_Home_L.ab99fd9b.jpg";